import { createAction } from 'redux-actions';

export const clearReservationToday = createAction('CLEAR_RESERVATION_TODAY');

export const reservationTodayOnChangePage = createAction(
  'RESERVATION_TODAY_ON_CHANGE_PAGE'
);

export const reservationTodayOnChangeOrder = createAction(
  'RESERVATION_TODAY_ON_CHANGE_ORDER'
);
